import styled from "styled-components";

const PageContent = styled.div`
  padding: 2rem;
  width: ${(props) => (props.$fullWidth ? "100%" : "60rem")};
  margin: 80px auto 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export default PageContent;
